import { siteName, legalEmail } from 'config/site';
import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 4 }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 3 }}
        >
          Back
        </Button>

        <Paper elevation={2} sx={{ p: 4 }}>
          <Typography variant="h3" gutterBottom fontWeight={700}>
            Terms & Conditions
          </Typography>
          <Typography variant="caption" color="text.secondary" gutterBottom display="block" sx={{ mb: 4 }}>
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing and using {siteName}, you accept and agree to be bound by the terms
            and provision of this agreement. If you do not agree to these terms, please do not use our service.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            2. Use License
          </Typography>
          <Typography paragraph>
            We grant you a personal, non-transferable, non-exclusive license to use {siteName}
            for creating and managing your resumes. This license is subject to your compliance with these Terms.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            3. User Account
          </Typography>
          <Typography paragraph>
            To use our service, you must:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Create an account with accurate information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Be at least 13 years old</li>
            <li>Notify us immediately of any unauthorized access</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            4. Prohibited Uses
          </Typography>
          <Typography paragraph>
            You may not use {siteName} to:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Violate any laws or regulations</li>
            <li>Upload malicious code or viruses</li>
            <li>Impersonate another person or entity</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Generate false or misleading information</li>
            <li>Circumvent security measures</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            5. Content Ownership
          </Typography>
          <Typography paragraph>
            You retain all rights to the content you create using our service. By using our service, 
            you grant us permission to process and store your content solely for providing the service to you.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            6. AI-Generated Content
          </Typography>
          <Typography paragraph>
            Our service uses AI (OpenAI) to generate resume content. While we strive for accuracy:
          </Typography>
          <Typography component="ul" paragraph>
            <li>You are responsible for reviewing and verifying all generated content</li>
            <li>AI-generated content may require editing for accuracy</li>
            <li>We make no guarantees about the quality or suitability of generated content</li>
            <li>You should ensure all information is truthful and accurate</li>
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            7. Service Availability
          </Typography>
          <Typography paragraph>
            We strive to provide continuous service but do not guarantee:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Uninterrupted access to the service</li>
            <li>Error-free operation</li>
            <li>Availability of any particular feature</li>
          </Typography>
          <Typography paragraph>
            We reserve the right to modify, suspend, or discontinue the service at any time.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            8. Limitation of Liability
          </Typography>
          <Typography paragraph>
            To the maximum extent permitted by law, {siteName} shall not be liable for any
            indirect, incidental, special, consequential, or punitive damages resulting from your use
            of or inability to use the service.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            9. Indemnification
          </Typography>
          <Typography paragraph>
            You agree to indemnify and hold harmless {siteName} from any claims, damages, or
            expenses arising from your use of the service or violation of these terms.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            10. Termination
          </Typography>
          <Typography paragraph>
            We may terminate or suspend your account immediately, without prior notice, for:
          </Typography>
          <Typography component="ul" paragraph>
            <li>Violation of these Terms</li>
            <li>Fraudulent or illegal activity</li>
            <li>Any other conduct we deem inappropriate</li>
          </Typography>
          <Typography paragraph>
            You may delete your account at any time from your account settings.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            11. Changes to Terms
          </Typography>
          <Typography paragraph>
            We reserve the right to modify these terms at any time. We will notify users of any 
            material changes. Continued use of the service after changes constitutes acceptance of the new terms.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            12. Governing Law
          </Typography>
          <Typography paragraph>
            These Terms shall be governed by and construed in accordance with the laws of the jurisdiction
            in which {siteName} operates, without regard to its conflict of law provisions.
          </Typography>

          <Typography variant="h5" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            13. Contact Information
          </Typography>
          <Typography paragraph>
            For questions about these Terms, please contact us at:
            <br />
            <strong>Email:</strong> {legalEmail}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms;

